module.exports = __webpack_public_path__ + "img/nav-design-ringsets@2x.68eca20.jpg";